import React, { useEffect, useRef, useState } from "react";
import Header from "../../Components/Header";
import moment from "moment";
import {
    Client_Search,
    Dashboard_Client_Report,
    MtfPMR,
    MutualFund,
} from "../../Configuration/API_URL";
import {
    AESEncryption,
    ApiResDecrypt,
    checkDateRange,
    compareDate,
    noDataFound,
} from "../../CommonMethhods/CommonMethods";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import { Constants } from "../../CommonMethhods/Constants";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { useDebounce } from "../../Components/useDebounce";
import FnoDeliveryReportTable from "../../Components/ReportTables/FnoDeliveryReportTable";
import { useForm } from "react-hook-form";
import SmallLoader from "../../Components/Common/smallLoader";
import MTFPMRReportTable from "../../Components/ReportTables/MTFPMRReportTable";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function MTFPMRReport() {
    const storeToken = localStorage.getItem("ssoToken");
    const calanderIcon = true;
    const [clientList, setClientList] = useState([]);
    const [clientCode, setClientCode] = useState("");
    const [page, setPage] = useState(1);
    const [scrollLoader, setScrollLoader] = useState(false);
    const debouncedClientCode = useDebounce(clientCode, 1000);
    const [noNameFoundError, setNoNameFoundError] = useState("");
    const [count, setCount] = useState(0);
    const [fileType, setFileType] = useState("");
    const [show, setShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [dataCount, setDataCount] = useState();
    const [offset, setOffset] = useState(0);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [scrollLoaderTable, setScrollLoaderTable] = useState(false);
    const [mainError, setMainError] = useState(false);
    const [serverError, setServerError] = useState(false);
    const [fromDateError, setFromDateError] = useState(false);
    const [errorGrid, setErrorGrid] = useState(false);
    const [errorResp, setErrorResp] = useState("");
    const [hasVerticalScroll, setHasVerticalScroll] = useState(false);
    const [sipDate, setSipDate] = useState("");
    const [expandedRowId, setExpandedRowId] = useState(null);
    const tableBodyRef = useRef(null);
    const [hasMoreData, setHasMoreData] = useState(true);
    const [search, setSearch] = useState(false)
    const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
    const [showPmrTable, setShowPmrTable] = useState(false)
    // useEffect(() => {
    //     getMandateReport("grid", 0);
    // }, []);

    useEffect(() => {
        if (debouncedClientCode) {
            searchApiDetail(debouncedClientCode, 1);
            setScrollLoader(true);
            setClientList([]);
            setPage(1);
        }
    }, [debouncedClientCode]);
    useEffect(() => {
        if (page > 1) {
            searchApiDetail(clientCode, page);
        }
    }, [page]);
    const searchApiDetail = async (code, NoPage) => {
        const payloadValue = {
            keyword: code,
            Status: "",
            PageNo: NoPage,
            PageSize: 10,
        };
        const encPayload = AESEncryption(payloadValue);

        try {
            const response = await axiosInstance.post(
                Client_Search.Search_URL,
                `"${encPayload}"`,
            );

            const res = ApiResDecrypt(response?.data);

            if (res?.status === 0) {
                setFileType("");
                setCount(res?.data?.TotalCount);
                setNoNameFoundError("");
                setMainError("");
                setClientList((prev) =>
                    page > 1 ? [...prev, ...res?.data?.clients] : res?.data?.clients
                );
            } else {
                setNoNameFoundError(res?.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setScrollLoader(false);
        }
    };

    const handleScroll = async (e) => {
        const element = e.target;
        if (
            element.scrollTop + element.offsetHeight + 1 >= element.scrollHeight &&
            !scrollLoader
        ) {
            if (count > 10 * page) {
                setPage((prev) => prev + 1);
                setScrollLoader(true);
            }
        }
    };

    const getMandateReport = async (fileView, offsetTab) => {
        if (fileView === "excel") setSmallLoaderExcel(true);
        if (fileView === "pdf") setSmallLoaderPdf(true);
        if (fileView === "grid") setLoader(true);
        let payloadValue = {
            clientCode: clientCode,
            fromDate,
            toDate,
            fileType: fileView,
        };
        console.log(payloadValue, "payloadValue");

        let encPayload = AESEncryption(payloadValue);
        try {
            const getDetails = await axiosInstance.post(
                MtfPMR.mtfpmr,
                `"${encPayload}"`,
            );
            const res = ApiResDecrypt(getDetails?.data);
            console.log(res, "res");
            if (res?.status === 0) {
                if (fileView === "grid") {
                    // setDataCount(res?.data?.totalCnt);
                    setShowPmrTable(true)
                    if (offsetTab > 0) {
                        setTableData((prev) => [...prev, ...res?.data]);
                    } else {
                        setTableData(res?.data);
                    }
                    setScrollLoaderTable(false);
                } else if (fileView === "excel") {
                    window.open(res?.data, "_self", "noopener,noreferrer");
                } else if (fileView === "pdf") {
                    window.open(res?.data, "_blank", "noopener,noreferrer");
                } else {
                    toast.success("Mail sent successfully");
                }
            } else {
                setTableData([]);
                setShowPmrTable(false)
                if (fileView !== "grid") {
                    toast.error(res?.message);
                } else {
                    setErrorGrid(res?.message);
                }
            }
        } catch (error) {
            console.log(error);
            setServerError(error?.message);
            if (fileView !== "grid") {
                toast.error(error?.message);
            }
        } finally {
            setLoader(false);
            // setSearch(false)
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false)
        }
    };
    console.log(tableData, loader, "tableData");

    const handleFromDateChange = (e) => {
        if (e.target.value) {
            setOffset(0);
            const d = moment(e.target.value, "YYYY-MM-DD").format("MM-DD-YYYY");
            setFromDate(d);

            // ✅ Only clear Start Date error
            setFromDateError(false);
        } else {
            setFromDate("");
            // reset only this field error
            setFromDateError("Please Select Mandate Start Date");
        }
    };

    const handleToDateChange = (e) => {
        if (e.target.value) {
            setOffset(0);
            const d = moment(e.target.value, "YYYY-MM-DD").format("MM-DD-YYYY");
            setToDate(d);

            // ✅ Only clear End Date error
            setErrorResp(false);
        } else {
            setToDate("");
            // reset only this field error
            setErrorResp("Please Select Mandate End Date");
        }
    };

    function formatDateChng(date) {
        return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
    }
    const validateInputs = () => {
        let valid = true;
        // Reset errors
        setMainError(false);
        setFromDateError(false);
        setErrorResp(false);

        if (!clientCode) {
            setMainError("Please Select Client Name/Code");
            valid = false;
        }
        if (!fromDate) {
            setFromDateError("Please Select Mandate Start Date");
            valid = false;
        }
        if (!toDate) {
            setErrorResp("Please Select Mandate End Date");
            valid = false;
        }

        if (!valid) {
            setTableData([]);
            return false;
        }

        // ✅ Check if ToDate > Today
        const today = moment().startOf("day");
        const toDateMoment = moment(toDate, "MM-DD-YYYY");
        if (toDateMoment.isAfter(today)) {
            setErrorResp("Please Select Correct Date");
            setTableData([]);
            return false;
        }

        // ✅ Validate range
        if (!(compareDate(fromDate) && compareDate(toDate) && checkDateRange(fromDate, toDate))) {
            setErrorResp("Please Select Correct Date");
            setTableData([]);
            setShowPmrTable(false);
            return false;
        } else {
            setErrorResp(""); // clear error if valid
        }

        return true; // ✅ proceed to API
    };


    // const validateInputs = () => {
    //     let valid = true;
    //     // Reset errors
    //     setMainError(false);
    //     setFromDateError(false);
    //     setErrorResp(false);

    //     if (!clientCode) {
    //         setMainError("Please Select Client Name/Code");
    //         valid = false;
    //     }
    //     if (!fromDate) {
    //         setFromDateError("Please Select Mandate Start Date");
    //         valid = false;
    //     }
    //     if (!toDate) {
    //         setErrorResp("Please Select Mandate End Date");
    //         valid = false;
    //     }

    //     if (!valid) {
    //         setTableData([]);
    //         return false;
    //     }

    //     if (!(compareDate(fromDate) && checkDateRange(fromDate, toDate))) {
    //         setErrorResp("Invalid date range");
    //         setTableData([]);
    //         setShowPmrTable(false)
    //         return false;
    //     } else {
    //         setErrorResp("Please Select Correct Date");
    //     }

    //     return true;
    // };

    const handleOnClick = (e) => {
        e.preventDefault();
        setOffset(0);
        setShow(false);
        if (validateInputs()) {
            setShowPmrTable(true);
            setLoader(true);
            getMandateReport(e.target.value, 0);
        }
    };
    const handleExportClick = (fileType) => {
        if (validateInputs()) {
            getMandateReport(fileType, 0);
        }
    }
    const handleTableScroll = (e) => {
        const el = e.target;
        const scrolledToBottom =
            el.scrollTop + el.offsetHeight + 1 >= el.scrollHeight;

        if (scrolledToBottom && !scrollLoaderTable) {
            const nextOffset = offset + 1;
            const totalLoadedRecords = (offset + 1) * 10;

            if (dataCount > totalLoadedRecords) {
                console.log("Loading more data from scroller...");

                setOffset(nextOffset);
                setScrollLoaderTable(true);
                setLoader(false);
                getMandateReport("grid", nextOffset);
            } else {
                setScrollLoaderTable(false);
            }
        }
    };

    const currentDate = new Date();
    const yyyy = currentDate.getFullYear();
    let mm = currentDate.getMonth() + 1;
    let dd = currentDate.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    const FormatedDate = dd + "/" + mm + "/" + yyyy;
    const DateReverse = FormatedDate.split("/").reverse().join("-");
    const endMandateYear = yyyy + 30;
    const endMandateFormat = dd + "/" + mm + "/" + endMandateYear;
    const endMandate = endMandateFormat.split("/").reverse().join("-");
    useEffect(() => {
        if (!clientCode.trim()) {
            setShow(false);
        }
    }, [clientCode]);


    return (
        <>
            <Header portal={"RM"} />
            <SingleSignOnSideBar />
            <main id="main-content" className="reports interest-report-wrapper">
                <div className="card-box">
                    <h2 style={{ textAlign: "start", fontSize: "15px", fontWeight: "500", marginBottom: "15px" }}>MTF PMR Report</h2>
                    {/* Search Form */}
                    <div className="row input-field-wrapper mtf-wrap">
                        <div className="col-md-4 col-sm-4 col-12">
                            <div className="form-group">
                                <label className="form-label">Client Search<span style={{ color: "red" }}>*</span></label>
                                <div className="rm-custom-dropdown">
                                    <input
                                        type="text"
                                        className="input-st"
                                        placeholder="Search here"
                                        autoComplete="off"
                                        value={clientCode}
                                        onChange={(e) => {
                                            // const value = e.target.value.toUpperCase();
                                            // const alphanumericValue = value.replace(/[^A-Z0-9]/gi, ""); // Allow only A-Z and 0-9
                                            const start = e.target.selectionStart;
                                            const end = e.target.selectionEnd;
                                            let input = e.target.value;
                                            input = input
                                                .toUpperCase()
                                                .replace(/[^A-Z0-9\s]/g, "")
                                                .replace(/\s+/g, " ")
                                                .trimStart()
                                                .slice(0, 100);

                                            e.target.value = input;
                                            e.target.setSelectionRange(start, end);

                                            setClientCode(input);
                                            // setShow(true);
                                            if (input.trim() === "") {
                                                setShow(false);
                                            } else {
                                                setShow(true);
                                            }
                                        }}
                                    />
                                    <button
                                        className="rm-dropdown-btn"
                                        onClick={() => setShow(!show)}
                                    >
                                        <span className="icon-right-arrow-triangle"></span>
                                    </button>
                                    {show && (
                                        <ul className="rm-mapping-ap border-0" onScroll={handleScroll}>
                                            {clientList.map((item, i) => (
                                                <li
                                                    key={i}
                                                    className="rm-maping-item-wrapper"
                                                    onClick={() => {
                                                        setClientCode(item?.clientCode);
                                                        setShow(false);
                                                    }}
                                                >
                                                    <>
                                                        <div> {item?.clientname}</div>
                                                        <div> {item?.clientCode}</div>
                                                    </>
                                                </li>
                                            ))}
                                            {scrollLoader && !loader && (
                                                <div className="loader-center">
                                                    <LoaderForSearch />
                                                </div>
                                            )}
                                            {noNameFoundError && !scrollLoader && (
                                                <li
                                                    className="rm-maping-item-wrapper"
                                                    style={{ borderBottom: "none", fontSize: "12px" }}
                                                >
                                                    {noNameFoundError}
                                                </li>
                                            )}
                                        </ul>
                                    )}
                                </div>
                                {mainError && (
                                    <span className="to-date-error main" style={{ bottom: "-8px" }}>{mainError}</span>
                                )}
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 col-12">
                            <div className="form-group calendar-icon">
                                <label className="form-label"> From Date<span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="date"
                                    placeholder="DD/MM/YYYY"
                                    className="datepicker form-control"
                                    id="FromDateCombine"
                                    onChange={handleFromDateChange}
                                    // defaultValue={formatDateChng(fromDate)}
                                    max={DateReverse}
                                />
                                <span className="to-date-error">{fromDateError}</span>
                                {calanderIcon && <span className="icon-calendar ico"></span>}
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 col-12">
                            <div className="form-group calendar-icon">
                                <label className="form-label">To Date<span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="date"
                                    placeholder="DD/MM/YYYY"
                                    className="datepicker form-control"
                                    id="ToDate"
                                    onChange={handleToDateChange}
                                    // defaultValue={formatDateChng(toDate)}
                                    // max={DateReverse}
                                    max={new Date().toISOString().split("T")[0]}
                                // max={DateReverse}
                                />
                                <span className="to-date-error">{errorResp}</span>
                                {calanderIcon && <span className="icon-calendar ico"></span>}
                            </div>
                        </div>
                    </div>
                    <div className="text-center search-btn-wrapper">
                        <button className="send-message" onClick={handleOnClick} value="grid" type="submit" disabled={loader}  >
                            {Constants.Search}
                        </button>
                    </div>
                    {/* <div className="text-center search-btn-wrapper mb-4">

                        <button
                            value="grid"
                            onClick={handleOnClick}
                            className="send-message"
                        >
                            {" "}
                            {search ? (
                                <div>
                                    <SmallLoader />
                                </div>
                            ) : (
                                <>
                                   
                                    {"Search"}
                                </>
                            )}
                        </button>
                    </div> */}
                    {/* Excel / PDF Buttons */}
                    <div>
                        <div className="table-top-nav">
                            <div className="table-dt-btn">
                                <button
                                    value="excel"
                                    onClick={() => handleExportClick("excel")}
                                    className="generate-button excel-btn"
                                //  disabled={tableData.length > 0 ? false : true}
                                >
                                    {" "}
                                    {smallLoaderExcel ? (
                                        <div>
                                            <SmallLoader />
                                        </div>
                                    ) : (
                                        <>
                                            <span className="icon-excelsvg"></span>
                                            {"Excel"}
                                        </>
                                    )}
                                </button>
                                <button
                                    className="generate-button pdf-btn"
                                    value="pdf"
                                    onClick={() => handleExportClick("pdf")}
                                >
                                    {smallLoaderPdf ? (
                                        <div>
                                            <SmallLoader />
                                        </div>
                                    ) : (
                                        <>
                                            <span className="icon-pdfsvg"></span>
                                            {"PDF"}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>

                    </div>

                    {/* Data Grid */}
                    {showPmrTable &&
                        <div className="for-grid-section">
                            {loader ? (
                                <div className="loader-alignment">
                                    <Loader />
                                </div>
                            ) : tableData ? (
                                <div>
                                    <MTFPMRReportTable
                                        tableData={tableData}
                                        handleTableScroll={handleTableScroll}
                                        scrollLoaderTable={scrollLoaderTable}
                                    />
                                </div>
                            ) : serverError ? (
                                <h4 className="report-error-message">
                                    {noDataFound(serverError)}
                                </h4>
                            ) : errorGrid ? (
                                noDataFound(errorGrid)
                            ) : (
                                ""
                            )}
                        </div>
                    }

                </div>
            </main>
        </>
    );
}

export default MTFPMRReport;
